import React, { useState } from 'react';
import { BarChart3, Layers, FileText } from 'lucide-react';
import AnalyticsPage from '@pages/Admin/Analytics/AnalyticsPage';
import CustomReportBuilder from '@pages/Admin/CustomReportBuilder/CustomReportBuilder';
import './ReportsHub.css';

type TabKey = 'analytics' | 'custom' | 'reports';

const TABS: { key: TabKey; label: string; icon: React.ReactNode }[] = [
  { key: 'analytics', label: 'Analytics', icon: <BarChart3 size={16} /> },
  { key: 'custom', label: 'Custom Report Builder', icon: <Layers size={16} /> },
  { key: 'reports', label: 'Reports', icon: <FileText size={16} /> },
];

interface ReportsHubProps {
  ReportsComponent: React.ComponentType;
}

const ReportsHub: React.FC<ReportsHubProps> = ({ ReportsComponent }) => {
  const [activeTab, setActiveTab] = useState<TabKey>('analytics');

  return (
    <div className="reports-hub">
      <div className="reports-hub-tabs" role="tablist" aria-label="Reports sections">
        {TABS.map(tab => (
          <button
            key={tab.key}
            role="tab"
            aria-selected={activeTab === tab.key}
            className={`reports-hub-tab ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.icon} {tab.label}
          </button>
        ))}
      </div>

      <div className="reports-hub-content" role="tabpanel">
        {activeTab === 'analytics' && <AnalyticsPage />}
        {activeTab === 'custom' && <CustomReportBuilder />}
        {activeTab === 'reports' && <ReportsComponent />}
      </div>
    </div>
  );
};

export default ReportsHub;
